import { inboundShipmentIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const bulkDeleteShipments = {
  name: "bulkDeleteShipments" as const,
  input: z.object({
    inboundShipmentIds: z.array(inboundShipmentIdFormat.schema),
  }),
  output: z.object({ success: z.boolean() }),
};
